var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1499_2515)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "#C5DFF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807 523C807 944.946 573.293 1287 285 1287C-3.29263 1287 -237 944.946 -237 523C-237 101.054 -3.29263 -241 285 -241C573.293 -241 807 101.054 807 523Z",
    fill: "url(#paint0_linear_1499_2515)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 540C400 895.119 249.792 1183 64.5 1183C-120.792 1183 -271 895.119 -271 540C-271 184.881 -120.792 -103 64.5 -103C249.792 -103 400 184.881 400 540Z",
    fill: "url(#paint1_linear_1499_2515)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1499_2515",
    x1: 285,
    y1: -241,
    x2: 285,
    y2: 1287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98C7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1499_2515",
    x1: 64.5,
    y1: -103,
    x2: 64.5,
    y2: 1183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7F1FF",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1499_2515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgblue);
export default __webpack_public_path__ + "static/media/Bgblue.ec258bee3cec1b0ae20d87b7004e2e91.svg";
export { ForwardRef as ReactComponent };